import { api } from '@/services';
import { format, parse } from 'date-fns';

function formatarData(data) {
  console.log(data);
  return format(parse(data, 'dd/MM/yy HH:mm:ss', new Date()), 'dd/MM/yyyy');
}

export default {
  async fetchContainers({ commit, dispatch }, payload) {
    const keys = Object.keys(payload);
    const params = new URLSearchParams();
    for (const key of keys) {
      if (payload[key]) {
        params.append(key, payload[key]);
      }
    }
    dispatch('toggleLoading', true, { root: true });
    const response = await api.get('/processo/container', { params: params || [] });
    commit('SET_CONTAINERS', response.data);
    commit('paginacao/SET_PAGINADOR', response.data, { root: true });
    dispatch('toggleLoading', false, { root: true });
  },
  async prepararExcel({ getters }) {
    delete getters.getExcelFiltros.page;
    delete getters.getExcelFiltros.perPage;
    delete getters.getExcelFiltros.order;
    delete getters.getExcelFiltros.direcao;

    const keys = Object.keys(getters.getExcelFiltros);
    const params = new URLSearchParams();

    for (const key of keys) {
      if (getters.getExcelFiltros[key]) {
        params.append(key, getters.getExcelFiltros[key]);
      }
    }

    const { data } = await api.get('/processo/container/excel', { params });

    const excelFormatado = data.map((infoDist) => ({
      dataChegadaContainer: infoDist.dataChegadaContainer ? formatarData(infoDist.dataChegadaContainer) : null,
      dataEntregaContainer: infoDist.dataEntregaContainer ? formatarData(infoDist.dataEntregaContainer) : null,
      dataVencimentoFreetime: infoDist.dataVencimentoFreetime ? formatarData(infoDist.dataVencimentoFreetime) : null,
      freetime: infoDist.freetime,
      nomeArmador: infoDist.nomeArmador,
      numeroContainer: infoDist.numeroContainer,
      numeroHouse: infoDist.numeroHouse,
      numeroLacre: infoDist.numeroLacre,
      numeroMaster: infoDist.numeroMaster,
      referenciaCliente: infoDist.referenciaCliente,
      referenciaInterna: infoDist.referenciaInterna,
      tipoContainer: infoDist.tipoContainer,
    }));

    return excelFormatado;
  },
  async filtrarExcel({ commit }, payload) {
    commit('SET_EXCEL_FILTROS', payload);
  },
  async getContainersMes() {
    const { data } = await api.get('/processo/container/container-mes');
    return data;
  },
  async getContainersPortoMes() {
    const { data } = await api.get('/processo/container/container-porto-mes');
    return data;
  },
  async getContainersDiasFreeTime() {
    const { data } = await api.get('/processo/container/freetime-armadores');
    return data;
  },
  limparContainers({ commit }) {
    commit('SET_CONTAINERS', null);
  },
};
